import { Grid, Typography } from "@mui/material";
import parseHTML from "html-react-parser";
import React from "react";
import { useIntl } from "react-intl";

import { Button } from "../../common/components/Button/Button";

export interface PurposeProps {
  title: string;
  purpose: string;
  onContinue: () => void;
}

export const Purpose: React.FC<PurposeProps> = ({
  title,
  purpose,
  onContinue,
}) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <Grid
        item
        sx={{
          paddingTop: "9rem",
        }}
      >
        <Typography
          component="h1"
          fontSize="1.68rem"
          paddingBottom="2rem"
          fontWeight="700"
        >
          {title}
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          component="p"
          fontSize="1.2rem"
        >
          {parseHTML(purpose)}
        </Typography>
      </Grid>
      <Grid
        item
        sx={{
          marginTop: "auto",
          alignSelf: "center",
        }}
      >
        <Button
          type="primary"
          onClick={() => onContinue()}
        >
          <Typography
            fontSize="1.15rem"
            fontWeight="700"
            component="span"
          >
            {formatMessage({ id: "purpose.continue" })}
          </Typography>
        </Button>
      </Grid>
    </>
  );
};
